// Scrolls the active category into view on narrow screens so it is never hidden off the edge; each row scrolls on its own.
class SCollectionNav extends HTMLElement {
  connectedCallback() {
    for (const track of this.querySelectorAll('[data-nav-track]')) {
      const active = track.querySelector('[aria-current="page"]');
      if (!active || track.scrollWidth <= track.clientWidth) continue;
      const trackBox = track.getBoundingClientRect();
      const activeBox = active.getBoundingClientRect();
      const delta = activeBox.left + activeBox.width / 2 - (trackBox.left + trackBox.width / 2);
      track.scrollLeft += delta;
    }
  }
}

customElements.define('s-collection-nav', SCollectionNav);
